module.exports = __webpack_public_path__ + "img/17.c8b9ac45.jpg";